import { AdminInvoiceReports } from '@/features/admin_invoice_reports';

const AdminInvoiceReportsPage = () => {
  return <AdminInvoiceReports />;
};

export default AdminInvoiceReportsPage;
